import PropTypes from "prop-types";
import { connect } from "react-redux";
import selectors from "selectors";
import Logo from "assets/images/S3_WellSky_color_RGB 3.svg";

const UserWelcome = ({ userDetails }) => {
  return (
    <div className="user-welcome" role="banner" aria-label="Company information">
      <img src={Logo} alt="WellSky logo" />
      <span aria-label={`Company: ${userDetails.company_name}`}>{userDetails.company_name}</span>
    </div>
  );
};

UserWelcome.propTypes = {
  userDetails: PropTypes.shape({
    company_name: PropTypes.string
  }).isRequired
};

export default connect(state => ({
  userDetails: selectors.getUserDetails(state)
}))(UserWelcome);
